import { render, staticRenderFns } from "./contract-update.vue?vue&type=template&id=0522267c&scoped=true"
import script from "./contract-update.vue?vue&type=script&lang=js"
export * from "./contract-update.vue?vue&type=script&lang=js"
import style0 from "./contract-update.vue?vue&type=style&index=0&id=0522267c&prod&scoped=true&lang=css"
import style1 from "./contract-update.vue?vue&type=style&index=1&id=0522267c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0522267c",
  null
  
)

export default component.exports